import {cloneDeep} from 'lodash'
import {ModuleFc} from '@/project'
import {ExternalState, GetInvoiceDocumentRequest} from './types'
import {updateObject} from '@/store/utils'

const initState: ExternalState = {
  invoiceDocumentData: '',
  registrationNumber: '',
  invoice: {
    id: '',
    status: '',
    errorCode: '',
    isForcedPayment: false,
    confirmNumber: '',
    mainItemName: '',
    totalAmount: 0,
    totalSupply: 0,
    totalTax: 0,
    isTaxFree: false,
    writeDate: '',
    issueDate: '',
    sendDate: '',
    issueType: '',
    purposeType: '청구',
    cash: 0,
    checkBill: 0,
    credit: 0,
    note: 0,
    remark: '',
    bizName: '',
    bizOwnerName: '',
    bizAddress: '',
    bizClass: '',
    bizType: '',
    bizEmail: '',
    bizSubEmail: '',
    bizNumber: '',
    bizTaxNumber: '',
    clientId:'',
    clientName: '',
    clientOwnerName: '',
    clientAddress: '',
    clientBizClass: '',
    clientBizType: '',
    clientType: '',
    clientEmail: '',
    clientSubEmail: '',
    clientBizNumber: '',
    clientTaxNumber: '',
    items: []
  }
}

const module: ModuleFc<ExternalState> = (ctx) => {
  return {
    namespaced: true,
    state: cloneDeep(initState),
    mutations: {
      update(state, payload: ExternalState) {
        updateObject(state, payload)
      },
      remove(state, payload: string) {
        state[payload] = cloneDeep(initState[payload])
      },
      clear(state) {
        updateObject(state, cloneDeep(initState))
      },
    },
    actions: {
      async getInvoice({commit}, payload: {invoiceId: string, registrationNumber: string}) {
        const result = await ctx.$axios({
          url: '/external/invoices/$id',
          method: 'post',
          params: {
            invoiceId: payload.invoiceId,
          },
          data: {
            registrationNumber: payload.registrationNumber,
          }
        })
        commit('update', {invoice: result.data})
        return result.data
      },
      async getReview(_, payload: GetInvoiceDocumentRequest) {
        const {data} = await ctx.$axios({
          url: '/external/invoice-review',
          method: 'post',
          params: {
            invoiceId: payload.invoiceId,
            type: payload.type,
          },
          data: {
            registrationNumber: payload.registrationNumber,
          },
        })
        return data
      },
      async getInvoiceFile(_, payload: {invoiceId: string, registrationNumber: string}) {
        const {data} = await ctx.$axios({
          url: '/external/invoice-review/download',
          params: {
            invoiceId: payload.invoiceId
          },
          data: {
            registrationNumber: payload.registrationNumber,
          },
          method: 'post',
        })
        return data
      },
    }
  }
}

export default module
